function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHamburger(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.509 8.796H1.93c-.798 0-1.451.653-1.451 1.451 0 .799.653 1.452 1.451 1.452H19.51c.798 0 1.451-.653 1.451-1.452 0-.798-.639-1.451-1.451-1.451z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.931 2.903H19.51c.798 0 1.451-.653 1.451-1.452C20.96.653 20.307 0 19.509 0H1.93C1.133 0 .48.653.48 1.451c0 .799.653 1.452 1.451 1.452z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.509 17.577H1.93c-.798 0-1.451.653-1.451 1.452 0 .798.653 1.451 1.451 1.451H19.51c.798 0 1.451-.653 1.451-1.451 0-.799-.639-1.452-1.451-1.452z",
    fill: props.color
  }));
}

SvgHamburger.defaultProps = {
  color: "#000",
  title: "Hamburger"
};
export default "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJyZWFjdC1jb21wb25lbnRzL2ljb25zL0hhbWJ1cmdlci0zODQyMGUxYmI0NjkwMzgwY2E0N2YxMDA3ZmUwYzMyMy5zdmciOw==";
export { SvgHamburger as ReactComponent };